import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

import { SvgStyled } from './icons.styles';

export const WindowsIcon = forwardRef<SVGSVGElement, IconProps>(function WindowsIcon(
  { color = '', height = 18, width = 18, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24425 1.41913L17.9977 0V8.53345L8.24425 8.61065V1.41913ZM7.35603 1.54978L0 2.54851L0.0067197 8.66516L7.35924 8.62342L7.35603 1.54978ZM7.35824 16.5182L7.35253 9.43835L0.00529861 9.39086L0.00571087 15.5104L7.35824 16.5182ZM17.9977 18L18 9.50497L8.23056 9.48907L8.24423 16.6276L17.9977 18Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
